import { createContext } from "react";

export default createContext({
    room: {},
    persons: {},
    setIndex: () => {}
});
